import DesignFacade from '../../../facade/design/design';
import ImagesFactory from '../../images';

module.exports = {
  listeners: {},

  initialize: function (RestrictionsFactory) {
    _.bindAll(this, 'onNewSource');
    this.restrictionsFactory = RestrictionsFactory;
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
  },

  refresh: function (permissions) {
    const restrictions = JSON.parse(permissions.get('restrictions') || '{}');
    const elementId = permissions.get('element_id');

    if (restrictions.source && restrictions.source.list) {
      this.listeners[elementId] || this.addListener(elementId, permissions);
    } else if (this.listeners[elementId]) {
      this.removeListener(elementId);
    }
  },

  removeListener: function (elementId) {
    this.listeners = _.omit(this.listeners, elementId);
    DesignFacade.off(elementId + '.source.url', this.onNewSource);
  },

  addListener: function (elementId, permissions) {
    this.listeners[elementId] = permissions;
    DesignFacade.on(elementId + '.source', this.onNewSource);
  },

  onNewSource: function (options) {
    const elementId = options.id;
    const url = ImagesFactory.getVersionUrl(options.source.url, 'thumb') ||
      options.source.url.replace('/original/', '/thumb/');
    const restrictions = JSON.parse(this.listeners[elementId]?.get('restrictions') || '{}');

    if (restrictions.source && restrictions.source.list) {
      if (!restrictions.source.list.map((source) => ImagesFactory.getVersionUrl(source, 'thumb')).includes(url)) {
        this.canvas.call('advice.show', 'source-restriction-applied');
        restrictions.source.list.push(url);

        this.restrictionsFactory.setGlobalElementRestriction(
          elementId, JSON.stringify(restrictions)
        );
      }
    } else if (this.listeners[elementId]) {
      this.removeListener(elementId);
    }
  }
};
